import { lazy } from "react";
import Loadable from "app/components/Loadable";

const AdminOfficeLocations = Loadable(
  lazy(() => import("./AdminOfficeLocations")),
);
const LocationsList = Loadable(lazy(() => import("./OfficeLocationList")));

const OfficeLocationRoutes = [
  { path: "ems/office/locations", element: <LocationsList /> },
  {
    path: "ems/office/locations/:mode/:id",
    element: <AdminOfficeLocations />,
  },
];

export default OfficeLocationRoutes;
